import { Injectable } from "@angular/core";
import { FormMapaATControlNames } from "../../formMapaATControlNames";
import { DescriptionReduite } from "../../models/DescriptionReduite";
import { TypeCPVClass } from "../../models/TypeCPVClass";
import { TypeFournitures } from "../../models/TypeFournitures";
import { TypeLieu } from "../../models/TypeLieu";
import { TypeObjCPV } from "../../models/TypeObjCPV";
import { TypeTravaux } from "../../models/TypeTravaux";
import { TypeVoie } from "../../models/TypeVoie";

@Injectable({
    providedIn: 'root'
})


export class DescriptionReduiteService {

    constructor() {
    }
    setValueFromControlName(value: any, attribut: any[]) {
        if (value && value != '') {
            attribut[attribut.length++] = value;
        }
    }

    public getDescriptionReduite(controls, formExtractorService): DescriptionReduite {

        const classSupplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), [''], '_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeObjCPV_SepSep_TypeCPVClass_index_');
        const objclassSupplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeObjCPV_index_'], '_SepSep_TypeCPVClass_index_');
        const objetComplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['SepSep_TypeCPVClass'], '_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeObjCPV_index_');
        let classSupplementaire_iter = 0;
        let objetComplementaire_iter = 0;

        const descriptionReduite = new DescriptionReduite();
        descriptionReduite.objet = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepAtt_objet')
        descriptionReduite.marcheServices = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepAtt_marcheServices')

        descriptionReduite.lieuExecutionLivraison = new TypeLieu();
        descriptionReduite.lieuExecutionLivraison.ville = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecutionLivraison_SepSep_TypeLieu_SepAtt_ville')
        descriptionReduite.lieuExecutionLivraison.cp = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecutionLivraison_SepSep_TypeLieu_SepAtt_cp')

        descriptionReduite.cpv = new TypeObjCPV();

        descriptionReduite.cpv.objetPrincipal = new TypeCPVClass();
        descriptionReduite.cpv.objetPrincipal.classPrincipale = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')
        classSupplementaire_iter = 0;
        classSupplementaire_iters.forEach(() => {

            const controlName = '_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeObjCPV_SepSep_TypeCPVClass_index_' + (Number(classSupplementaire_iter + 1)) + '_SepAtt_classSupplementaire';
            this.setValueFromControlName(controls.get(controlName), descriptionReduite.cpv.objetPrincipal.classSupplementaire);
            classSupplementaire_iter++;
        });

        descriptionReduite.lieuExecution = new TypeLieu();
        descriptionReduite.lieuExecution.cp = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecution_SepSep_TypeLieu_SepAtt_cp')
        descriptionReduite.lieuExecution.ville = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecution_SepSep_TypeLieu_SepAtt_ville')

        descriptionReduite.lieuExecution.voie = new TypeVoie();
        descriptionReduite.lieuExecution.voie.nomvoie = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecution_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie')
        descriptionReduite.lieuExecution.voie.typevoie = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecution_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie')
        descriptionReduite.lieuExecution.voie.num = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecution_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num')

        descriptionReduite.marcheFournitures = new TypeFournitures();
        descriptionReduite.marcheFournitures.location = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeFournitures_SepAtt_location')
        descriptionReduite.marcheFournitures.locationVente = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeFournitures_SepAtt_locationVente')
        descriptionReduite.marcheFournitures.creditBail = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeFournitures_SepAtt_creditBail')
        descriptionReduite.marcheFournitures.achat = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeFournitures_SepAtt_achat')

        objetComplementaire_iter = 0;
        objetComplementaire_iters.forEach(() => {
            descriptionReduite.cpv.objetComplementaire[objetComplementaire_iter] = new TypeCPVClass();
            descriptionReduite.cpv.objetComplementaire[objetComplementaire_iter].classPrincipale = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeObjCPV_index_' + (Number(objetComplementaire_iter + 1)) + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')

            classSupplementaire_iter = 0;
            objclassSupplementaire_iters.forEach(() => {
                const controlName = '_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeObjCPV_index_' + (Number(objetComplementaire_iter + 1)) + '_SepSep_TypeCPVClass_index_' + (Number(classSupplementaire_iter + 1)) + '_SepAtt_classSupplementaire';
                this.setValueFromControlName(controls.get(controlName), descriptionReduite.cpv.objetComplementaire[objetComplementaire_iter].classSupplementaire);
                classSupplementaire_iter++;
            });
            objetComplementaire_iter++;
        });

        descriptionReduite.marcheTravaux = new TypeTravaux();
        descriptionReduite.marcheTravaux.conceptionRealisation = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeTravaux_SepAtt_conceptionRealisation')
        descriptionReduite.marcheTravaux.execution = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_SepSep_TypeTravaux_SepAtt_execution')

        descriptionReduite.lieuLivraison = new TypeLieu();
        descriptionReduite.lieuLivraison.cp = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuLivraison_SepSep_TypeLieu_SepAtt_cp')
        descriptionReduite.lieuLivraison.ville = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuLivraison_SepSep_TypeLieu_SepAtt_ville')

        descriptionReduite.lieuLivraison.voie = new TypeVoie();
        descriptionReduite.lieuLivraison.voie.typevoie = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie')
        descriptionReduite.lieuLivraison.voie.num = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num')
        descriptionReduite.lieuLivraison.voie.nomvoie = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie')

        descriptionReduite.lieuExecutionLivraison.voie = new TypeVoie();
        descriptionReduite.lieuExecutionLivraison.voie.typevoie = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecutionLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie')
        descriptionReduite.lieuExecutionLivraison.voie.num = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecutionLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num')
        descriptionReduite.lieuExecutionLivraison.voie.nomvoie = controls.get('_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite_lieuExecutionLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie')

        return descriptionReduite;
    }
}
